var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg))]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderNumber')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ponoFlt",
      "placeholder": _vm.$t('common.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.ponoFlt),
      callback: function($$v) {
        _vm.ponoFlt = $$v
      },
      expression: "ponoFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.shipmentId')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "shipidflt",
      "placeholder": _vm.$t('common.shipmentIdPlaceHolder')
    },
    model: {
      value: (_vm.shipidflt),
      callback: function($$v) {
        _vm.shipidflt = $$v
      },
      expression: "shipidflt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.hideShowdateFlt]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.orderStatusPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.orderstatuslist), function(ordstatus) {
    return _c('option', {
      domProps: {
        "value": ordstatus.status
      }
    }, [_vm._v(_vm._s(ordstatus.status))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromShipDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFltShip),
      callback: function($$v) {
        _vm.fromDateFltShip = $$v
      },
      expression: "fromDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toShipDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFltShip),
      callback: function($$v) {
        _vm.toDateFltShip = $$v
      },
      expression: "toDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.orderList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.resultCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-319px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.downloadButtonFlag == true) ? _c('span', [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-205px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getOrderList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listOrdersData.length) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-170px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": _vm.$t('common.downloadXls')
    },
    on: {
      "click": function($event) {
        _vm.getOrderListForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-170px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": _vm.$t('common.downloadXls'),
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.order')) + " #")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalQTY')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.processStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipByDate')))])])])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.orderQtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listOrdersData), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'orderdetailsAccordian',
          params: {
            poid: data.orderid,
            clientid: data.clientid,
            warehouseid: data.warehouseid
          },
          query: {
            clientid: _vm.encryptData(_vm.clientid),
            warehouseid: _vm.encryptData(_vm.warehouseid)
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.orderid))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormatFRT(data.createddatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalsku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentcnt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.processstatus) + "\n")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormatFRT(data.shipbydate)))])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": _vm.$t('multiSellerPanel.poDetails')
    },
    model: {
      value: (_vm.showinvoicemodal),
      callback: function($$v) {
        _vm.showinvoicemodal = $$v
      },
      expression: "showinvoicemodal"
    }
  }, [_c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "orderinvoiceContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('i', {
    on: {
      "ok": function($event) {}
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "12px"
    },
    attrs: {
      "width": "100%",
      "border": "1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%",
      "colspan": "2"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.name')) + ":")]), _vm._v("  " + _vm._s(_vm.clientdata.clientname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.address')) + ":")]), _vm._v("  " + _vm._s(_vm.clientdata.clientaddress) + "," + _vm._s(_vm.clientdata.clientaddress2) + "," + _vm._s(_vm.clientdata.city) + " –\n                        " + _vm._s(_vm.clientdata.pincode))]), _vm._v("\n                        Ph :- 18002082222")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.receiverDetails')) + ":")])]), _c('br'), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.name')) + ":")]), _vm._v(_vm._s(_vm.shippingdata.customerfirstname) + " " + _vm._s(_vm.shippingdata.customerlastname) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.gstIn')) + ": ")]), _vm._v("36AALCM3440J1ZB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.address')) + ": ")]), _vm._v(_vm._s(_vm.shippingdata.custaddress1) + "," + _vm._s(_vm.shippingdata.custstate) + "," + _vm._s(_vm.shippingdata.custcity)), _c('br'), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.cin')) + ":")]), _vm._v(" U72900TG2017PTC119669")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.state')) + ": ")]), _vm._v(_vm._s(_vm.shippingdata.custstate))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('common.dlNo')) + ":")]), _vm._v(" TS-RR-20-2018-38388 , TS-RR-21-2018-38388")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('multiSellerPanel.stateUiCode')) + ": ")]), _vm._v(" " + _vm._s(_vm.shippingdata.custpincode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.orderID')) + ":")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.orderid))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.gstUniqueId')) + ":")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.serialNoInvoice')) + ": ")]), _vm._v(_vm._s(_vm.shippingdata.invoicenumber))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.docName')) + ":")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.doctorname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.dateOfInvoice')) + ": ")]), _c('span', [_vm._v(_vm._s(_vm.shippingdata.shippingoutdate))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('common.address')) + ":")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.doctoraddress))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "font-size": "10px",
      "border-spacing": "0px !important",
      "mragin-top": "5px"
    },
    attrs: {
      "border": "1",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {}, [_c('th', {
    staticStyle: {
      "width": "8%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.itemDescription')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "max-width": "8%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.manufacturer')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.strength')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.batchNumber')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.expiryDate')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.hsnSac')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.qty')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.uom')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.mrpPerItem')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.totalMrp')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.discountAmount')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.amountPayable')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.taxableValue')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cgst')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.sgst')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.igst')) + " ")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.rate')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.amt')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.rate')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.amt')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.rate')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.amt')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shippinginvoicedatacal), function(invoicedata) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "8%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.strength))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.lotcontrol))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [(invoicedata.expirydate != null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(invoicedata.expirydate)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.hsncode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(invoicedata.pickqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v(_vm._s(invoicedata.primaryuom))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.mrp)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.totalmrp)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(invoicedata.discount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.amountpayable)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.taxablevalue)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(invoicedata.cgstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.cgstamount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(invoicedata.sgstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.sgstamount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(invoicedata.igstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatPrice(invoicedata.igstamount)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "8%",
      "font-size": "11px",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.total')))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.totalqty))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.grdtotalmrp)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalamountpayable)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totaltaxablevalue)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalcgstamt)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalsgstamt)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totaligstamt)))])])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "10px"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr'), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.totalAmountPayable')) + ": ₹ " + _vm._s(_vm.formatPrice(_vm.totalamountpayable)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.deliveryCharges')) + ": ₹ " + _vm._s(_vm.shippingcharges))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.totalInvoice')) + ": ₹ " + _vm._s(_vm.formatPrice(_vm.totalamountpayable + _vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.totalInvoiceInWord')) + ": " + _vm._s(_vm.number2text(_vm.totalamountpayable + _vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.amountTaxSubject')) + ": NIL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.remarks')) + ":")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px",
      "padding-left": "4px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "70%",
      "rowspan": "4"
    }
  }, [_c('span', [_c('p', [_c('br'), _vm._v(_vm._s(_vm.$t('multiSellerPanel.customerAcknowledgement'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('multiSellerPanel.acknowledgementMsg'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('multiSellerPanel.refferMsg'))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('multiSellerPanel.registeredOffice')) + ":-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('multiSellerPanel.addressMsg')) + " – 500 085.")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('multiSellerPanel.pharmacistSignature')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "15%",
      "colspan": "3"
    }
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.invoicephname) + "  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "15%",
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.$t('multiSellerPanel.rpNumber')) + "  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.date')) + "  ")])])])])])])])])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary  glass",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "19px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s('Print')
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.print')))])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "shipmentdetails"
    },
    model: {
      value: (_vm.shipmentdetails),
      callback: function($$v) {
        _vm.shipmentdetails = $$v
      },
      expression: "shipmentdetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('common.shipmentDetailsForOrder')) + " : " + _vm._s(_vm.orderidshipment) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.shipmentDetailsClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rejectReason')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentdetailslist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data._id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.skuquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.reject_reason))])])
  }), _vm._v(" "), (_vm.shipmentdetailslist.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9c9742a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c9742a8","hasScoped":true}!./src/views/components/multiseller/multisellerorder/multisellerorder.component.html
// module id = 1921
// module chunks = 0